var _style, _path, _defs, _defs2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgF4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t\n\t\t.st1{clip-path:url(#SVGID_00000090990549104853059280000008101271771318851241_);stroke:#000000;stroke-width:5;stroke-miterlimit:10;}\n\t\n\t\t.st2{clip-path:url(#SVGID_00000167380037361527677950000007878493005015667585_);stroke:#000000;stroke-width:5;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#000000;stroke-width:5;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M855.7,1000H144.3C64.9,1000,0,935.1,0,855.7V144.3C0,64.9,64.9,0,144.3,0h711.4C935.1,0,1000,64.9,1000,144.3 v711.4C1000,935.1,935.1,1000,855.7,1000z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000091737568550063172640000000077759238667729549_",
    d: "M856,45H144c-6.6,0-12,5.4-12,12v886 c0,6.6,5.4,12,12,12h712c6.6,0,12-5.4,12-12V57C868,50.4,862.6,45,856,45z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000147213103314107993420000000844729617862508169_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000091737568550063172640000000077759238667729549_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 45,
    style: {
      clipPath: "url(#SVGID_00000147213103314107993420000000844729617862508169_)",
      stroke: "#000000",
      strokeWidth: 5,
      strokeMiterlimit: 10
    },
    width: 736,
    height: 155.3
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000091737568550063172640000000077759238667729549_",
    style: {
      overflow: "visible",
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000158718014175379932820000004891622708397272985_",
    d: "M856,45H144c-6.6,0-12,5.4-12,12v886 c0,6.6,5.4,12,12,12h712c6.6,0,12-5.4,12-12V57C868,50.4,862.6,45,856,45z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000129889900400312364360000011419268034283773368_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000158718014175379932820000004891622708397272985_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 811.5,
    style: {
      clipPath: "url(#SVGID_00000129889900400312364360000011419268034283773368_)",
      stroke: "#000000",
      strokeWidth: 5,
      strokeMiterlimit: 10
    },
    width: 736,
    height: 143.5
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000158718014175379932820000004891622708397272985_",
    style: {
      overflow: "visible",
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    className: "st3",
    d: "M856,45H144c-6.6,0-12,5.4-12,12v886c0,6.6,5.4,12,12,12h712c6.6,0,12-5.4,12-12V57 C868,50.4,862.6,45,856,45z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgF4);
export default __webpack_public_path__ + "static/media/f4.7dc62e9f652e655645ed74309ffd12fe.svg";
export { ForwardRef as ReactComponent };